import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';
import { localNowIso } from '@/utils/datetime';
import { DashboardOptionsResponse, TodayDashboardResponse } from '../types/dashboard.types';
import { SortOrder } from './workout.service'; // Import SortOrder

/**
 * Отримати дані дашборду для конкретної дати
 * @param date - Дата у форматі YYYY-MM-DD. Якщо не вказана, отримує дані за сьогодні
 * @param sortOrder - Порядок сортування подій (ASC або DESC)
 */
export const getTodayDashboard = async (date?: string, sortOrder?: SortOrder): Promise<TodayDashboardResponse> => {
  const params: { date?: string; sortOrder?: SortOrder } = {};
  if (date) {
    params.date = date;
  }
  if (sortOrder) {
    params.sortOrder = sortOrder;
  }

  const response = await api.get<ApiResponse<TodayDashboardResponse>>('/dashboard', {
    params,
  });
  return unwrapApiResponse<TodayDashboardResponse>(response);
};

/**
 * Get the options for the dashboard widgets.
 */
export const getDashboardOptions = async (): Promise<DashboardOptionsResponse> => {
  const response = await api.get<ApiResponse<DashboardOptionsResponse>>('/dashboard/options');
  return unwrapApiResponse<DashboardOptionsResponse>(response);
};

/**
 * Додати воду через створення події рідини в календарі
 * @param waterMl - Кількість води в мілілітрах для додавання
 * @param date - Дата в ISO форматі. Якщо не вказана, використовується поточна дата
 */
export const incrementWater = async (waterMl: number, date?: string): Promise<void> => {
  const scheduledLdt = date ? date.slice(0, 19) : localNowIso();

  await api.post('/calendars/events/fluid/increment', {
    qty: waterMl,
    scheduledLdt,
  });
};

/**
 * Відняти воду через видалення останньої відповідної події рідини
 * @param waterMl - Кількість води в мілітрах для віднімання
 * @param date - Дата у форматі YYYY-MM-DD. Якщо не вказана, використовується сьогодні
 */
export const decrementWater = async (waterMl: number, date?: string): Promise<void> => {
  const targetDate = date || new Date().toISOString().split('T')[0];

  await api.post('/calendars/events/fluid/decrement', {
    qty: waterMl,
    date: targetDate,
  });
};
